/**
 * SMB Component - Show More/Less
 * @copyright 2018 AVAST Software s.r.o.
 * @author Erik Ondrus
 * @version 1.0
 * @since 2018-08
 *
 * DESCRIPTION:
 * Basic functionality of show more/less buttons
 *
 * OPTIONS:
 * 
 *
 * USAGE EXAMPLE:
 * <p class="js-showHide" data-show="UniqueIDOnPage"><span>Show More</span></p>
 *     <div class="hide js-showHideContent" data-show="UniqueIDOnPage">hidden content</div>
 * <p class="hide js-showHide js-showHide--mirror" data-show="UniqueIDOnPage">Show less</div>
 * 
 */
 
$(document).ready(function() {
        
    function showHide(e) {
        e.preventDefault();
        var data = $(this).attr('data-show'),        
            $content = $('.js-showHideContent'),
            $mirror = $(this).siblings($(this));
            
        $(this).toggleClass('active');
        
        $content.add($(this)).add($mirror).each(function(index, item) {
            $(item).attr('data-show') === data ? $(item).toggleClass('hide') : null;            
        });                            
    }
    
    //Handlers
    $('.js-showHide').on("click", showHide);
        
});